/* eslint-disable prefer-arrow/prefer-arrow-functions */
import Api from '@/services/ApiService';
import {
  User,
  CreateUserRequest,
  InviteUserRequest
} from '@/store/types/identity';

export default {
  find() {
    return Api.get('identity/users');
  },
  getUserInfo() {
    return Api.get('identity/user-profile');
  },
  getUserById(uuid: string) {
    return Api.get('identity/users/' + uuid);
  },
  createUser(user: CreateUserRequest) {
    return Api.post('identity/users', user);
  },
  updateUser(user: User) {
    return Api.put('identity/users/' + user.uuid, user);
  },
  inviteUser(user: InviteUserRequest) {
    return Api.post('ui/identity/users/invite', user);
  },
  deleteUser(userUuid: string) {
    return Api.delete(`identity/users/${userUuid}`);
  },
  approveUser(userUuid: string) {
    return Api.put(`ui/identity/users/${userUuid}/approve`, {});
  },
  revokeUser(userUuid: string) {
    return Api.put(`ui/identity/users/${userUuid}/revoke`, {});
  },
  resetPassword(id: string, data: string) {
    return Api.put(`identity/users/${id}/password-reset`, {
      password: data
    });
  },
  changePassword(id: string, oldPassword: string, password: string) {
    return Api.put(`identity/users/${id}/password`, {
      oldPassword: oldPassword,
      password: password
    });
  },
  getUsersNotInAccount(id: string) {
    return Api.get(
      `ui/identity/administration/accounts/${id}?usersNotInAccount`
    );
  },
  lockUser(id: string) {
    return Api.put(`identity/users/${id}/lock`, '');
  },
  unlockUser(id: string) {
    return Api.put(`identity/users/${id}/unlock`, '');
  },
  sendReceivedFeedback(feedback: string, rating: number) {
    return Api.post('ui/identity/feedback', {
      feedback: feedback,
      rating: rating
    });
  }
};
